module.exports = __webpack_public_path__ + "static/img/039_TO8_1532.51692bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/039_TO8_1532.jpg
// module id = TzE8
// module chunks = 0